var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('div',{attrs:{"id":"loading-container"}},[_c('v-progress-circular',{attrs:{"size":100,"width":5,"color":"#0D47A1","indeterminate":""}},[_c('v-img',{attrs:{"src":require('../assets/eclipse.png'),"max-width":"50","contain":""}})],1),_c('p',{staticClass:"text-subtitle-1 mt-4"},[_vm._v("Please wait...")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }